export default {
    set(state, { data }) {
      state.companies = data;
    },
    show(state, { data }) {
      state.company = data;
    }
  }